import React from "react";

export const Logo = ({ className = "", size = "text-2xl" }) => (
  <div className={`font-display font-black tracking-tighter leading-none select-none ${className}`} data-testid="dakid-logo">
    <span className={`${size} text-white`}>DAKID</span>
    <span className={`${size} text-blood glow-red ml-1.5`}>FILMS</span>
  </div>
);
